import { gql } from "lib/apolloClient";
import { gradeScaleToolFragment } from "./AssessmentGradeScaleToolFragments";

export const getGradeScalesQuery = gql`
  query getGradeScales(
    $id: ID!
    $gradeScaleFilters: GradeScaleFilters
    $gradingSetupEntityFilters: GradingSetupEntityFilters
  ) {
    node(id: $id, type: CURRICULUM_PROGRAM) {
      id
      ... on CurriculumProgram {
        id
        gradeScale(filters: $gradeScaleFilters) {
          edges {
            node {
              ...gradeScaleBasicDetailsItem
            }
          }
        }
      }
    }
  }
  ${gradeScaleToolFragment.gradeScaleBasicDetails}
`;

export const getGradeScaleDetailsQuery = gql`
  query getGradeScaleDetails($id: ID!) {
    node(id: $id, type: GRADE_SCALE_TOOL) {
      id
      ... on GradeScaleEntityDetail {
        ...gradeScaleEntityDetailItem
      }
    }
  }
  ${gradeScaleToolFragment.gradeScaleEntityDetail}
`;
